import { useState } from 'react';
import { createSupplier, patchSupplier, type Supplier } from './logistics-api';

// Добавление/правка поставщика.
export function SupplierEditModal({
  item,
  onClose,
  onSaved,
}: {
  item?: Supplier;
  onClose: () => void;
  onSaved: () => void;
}) {
  const edit = !!item;
  const [name, setName] = useState(item?.name ?? '');
  const [country, setCountry] = useState(item?.country ?? '');
  const [cat, setCat] = useState(item?.cat ?? '');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  async function save() {
    if (!name.trim()) {
      setMsg('Укажите название поставщика.');
      return;
    }
    setBusy(true);
    setMsg(null);
    try {
      if (edit) await patchSupplier(item!.id, { name: name.trim(), country, cat });
      else await createSupplier({ name: name.trim(), country, cat });
      onSaved();
    } catch (e) {
      setMsg(e instanceof Error ? e.message : 'Не удалось сохранить.');
      setBusy(false);
    }
  }

  return (
    <div className="ovl" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 420 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-h">
          <div className="grow">
            <div className="m-cli">{edit ? 'Правка поставщика' : 'Новый поставщик'}</div>
            <div className="m-no">справочник поставщиков</div>
          </div>
          <button className="icon-btn close-x" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="mbody">
          {msg && <p className="err">{msg}</p>}
          <label className="fld">
            <span className="fld-l">
              Название <span className="req">*</span>
            </span>
            <input
              value={name}
              disabled={busy}
              autoFocus
              placeholder="напр. МеталлТорг"
              onChange={(e) => setName(e.target.value)}
            />
          </label>
          <div style={{ display: 'flex', gap: 10 }}>
            <label className="fld" style={{ flex: 1 }}>
              <span className="fld-l">Страна</span>
              <input
                value={country}
                disabled={busy}
                placeholder="напр. Казахстан"
                onChange={(e) => setCountry(e.target.value)}
              />
            </label>
            <label className="fld" style={{ flex: 1 }}>
              <span className="fld-l">Категория</span>
              <input
                value={cat}
                disabled={busy}
                placeholder="напр. Металл / Электрика"
                onChange={(e) => setCat(e.target.value)}
              />
            </label>
          </div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 6 }}>
            <button className="btn ghost sm" disabled={busy} onClick={onClose}>
              Отмена
            </button>
            <button className="btn sm" disabled={busy} onClick={save}>
              {busy ? 'Сохраняем…' : 'Сохранить'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
